import React from 'react';

import { Typography } from '@mui/material';

import { Modal } from 'src/components/common';
import { InvitePeoPayrollProviderStaffByPEOPPModalForm } from 'src/components/peoPayrollProviderStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { PeoPayrollProviderStaffInviteModalArgs } from '../types';

export const InvitePeoPayrollProviderStaffByPEOPPModal: React.FC = () => {
  const { isOpen, closeModal, switchClosability } =
    useModal<PeoPayrollProviderStaffInviteModalArgs>(ModalId.PeoPayrollProviderInviteStaffModal);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite Staff"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={600}
      headerPadding="32px 32px 4px"
      headerProps={{
        sx: {
          lineHeight: '28px',
        },
      }}
      contentProps={{
        sx: {
          pt: 0,
        },
      }}
    >
      <Typography variant="body1" component="h4" mb={2} lineHeight="24px">
        Invite Staff by using their email address
      </Typography>
      <InvitePeoPayrollProviderStaffByPEOPPModalForm
        onCloseModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
